import { render, staticRenderFns } from "./restore_pim.vue?vue&type=template&id=287c050a&"
import script from "./restore_pim.vue?vue&type=script&lang=js&"
export * from "./restore_pim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports